import { useEffect, useState } from "react";
import { getFeature } from "../utils/features";
import { useFeaturesReady } from "../context/featuresReady/FeaturesReadyContext";

export default function useRemoveDiscountPercentage() {
  const [shouldRemoveDiscountPercentage, setShouldRemoveDiscountPercentage] =
    useState(false);
  const { areFeaturesReady } = useFeaturesReady();

  useEffect(() => {
    if (areFeaturesReady) {
      setShouldRemoveDiscountPercentage(
        getFeature("pdp_remove_discount_percentage").isEnabled()
      );
    }
  }, [areFeaturesReady]);

  return { shouldRemoveDiscountPercentage };
}
